module.exports = __webpack_public_path__ + "img/prague-card-image.670e8103.png";